/**
 * **La pastille de statut — neuf points, et c'est la charte qui le dit.**
 *
 * `DESIGN.md` : « **un statut se rend par une pastille de neuf points et un mot**, jamais
 * par une étiquette teintée. **Pastille pleine quand l'état a eu lieu, creuse quand rien
 * n'a eu lieu.** Trois teintes, un neutre et deux formes couvrent les onze états déclarés
 * du produit, dont les cinq simultanés de la demande de cours. »
 *
 * **Deux autres rendus ont été montés et écartés au banc d'essai du rendu de contrôle** :
 * « le contraste ne les départageait pas, la densité et la survie sur fond teinté si ».
 * Ce composant est donc le résultat d'un arbitrage déjà fait — le refaire ici serait
 * redécider une valeur de la charte.
 *
 * **Le fond teinté ne descend jamais dans une ligne de liste** : cette pastille n'en pose
 * aucun. C'est `Bandeau` qui porte un fond, et lui seul.
 */

export type TeinteDeStatut =
  | 'positif'
  | 'attention'
  | 'echec'
  | 'neutre'
  | 'eteint';

const PAR_TEINTE: Record<TeinteDeStatut, { plein: string; creux: string }> = {
  positif: { plein: 'bg-statut-positif', creux: 'border-statut-positif' },
  attention: { plein: 'bg-statut-attention', creux: 'border-statut-attention' },
  echec: { plein: 'bg-statut-echec', creux: 'border-statut-echec' },
  neutre: { plein: 'bg-statut-neutre', creux: 'border-statut-neutre' },
  eteint: { plein: 'bg-statut-eteint', creux: 'border-statut-eteint' },
};

type Props = {
  readonly teinte: TeinteDeStatut;
  /** Pleine quand l'état **a eu lieu**, creuse quand rien n'a eu lieu. */
  readonly pleine?: boolean;
};

export function Pastille({ teinte, pleine = true }: Props) {
  const formes = PAR_TEINTE[teinte];
  return (
    <span
      aria-hidden="true"
      className={[
        // Neuf points : la charte le dit en toutes lettres, et c'est la taille qui
        // survit sur fond teinté.
        'inline-block size-pastille shrink-0 rounded-plein',
        pleine ? formes.plein : `border-2 ${formes.creux}`,
      ].join(' ')}
    />
  );
}
